export default __webpack_public_path__ + "static/media/filter.002748a8.png";